import styles from './styles.module.less';
import classNames from 'classnames';
import { Spin, Result, Button, Skeleton, Empty } from 'antd';
import IntlMessages from 'util/IntlMessages';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ChildrenSchema } from 'packages/utils';
import BottonSpacing from 'components/BottonSpacing';
import { buildErrorResult } from 'util/customError';

/**
 *
 * @param {content} // going to center all the content and set a specific width
 */

const BoxContainer = ({
  children,
  content = false,
  shadow = false,
  fixed = false,
  loading = false,
  error = false,
  skeleton = false,
  empty = false,
  fullScreen = false,
  fullContent = false,
  className = '',
  contentClassName = '',
  bottomSpacing = null,
  onErrorCallback = null,
  bottomBorder = false,
  ...props
}) => {
  const history = useHistory();
  const initStyles = content ? styles.content : styles.wrapper;
  const fixedStyles = fixed && styles.fixed;
  const hasError = Boolean(error);
  const errorName = `${error?.name || ''}${error?.message || ''}${error?.code || ''}${
    error?.status || ''
  }${error?.error || ''}`;

  const errorResult = hasError ? buildErrorResult(errorName) : null;
  return (
    <div
      className={classNames(
        styles.main,
        shadow && styles.shadow,
        fixedStyles,
        fullScreen && styles.fullScreen,
        bottomBorder && styles.bottomBorder,
        className,
      )}
      {...props}
    >
      <Spin spinning={loading}>
        <div
          className={classNames(initStyles, fullContent && styles.fullContent, contentClassName)}
        >
          {!loading && empty && !hasError ? (
            <Empty description={<IntlMessages id="general.empty.state" />} />
          ) : !loading && hasError ? (
            <Result
              className={styles.errorContainer}
              status={errorResult.status}
              title={errorResult.title}
              subTitle={errorResult.subTitle}
              extra={
                <Button
                  onClick={() => (onErrorCallback ? onErrorCallback() : history.push('/'))}
                  type="primary"
                >
                  <IntlMessages id="button.goBack" />
                </Button>
              }
            />
          ) : loading && skeleton ? (
            <Skeleton />
          ) : (
            children
          )}
        </div>
      </Spin>
      {bottomSpacing && bottomSpacing?.active && (
        <div className={styles.bottonSpacingContainer}>
          <BottonSpacing align={bottomSpacing?.align}>{bottomSpacing?.content}</BottonSpacing>
        </div>
      )}
    </div>
  );
};

BoxContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, ChildrenSchema]),
  content: PropTypes.bool,
  shadow: PropTypes.bool,
  fixed: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.any,
  skeleton: PropTypes.bool,
  empty: PropTypes.bool,
  fullScreen: PropTypes.bool,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  bottomSpacing: PropTypes.shape({
    content: PropTypes.oneOfType([PropTypes.string, ChildrenSchema]),
    align: PropTypes.string,
    active: PropTypes.bool,
  }),
};
export default BoxContainer;
